import { useLocation, useNavigate } from "react-router-dom";

import { getLabel } from "../../../../hooks/use-labels";
import { setStorageItem } from "../../../../utils/common-utils";

const EmptyOrderView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { search, pathname, state } = location;

  const moveToAuth = () => {
    setStorageItem("redirectPath", { path: pathname + search, state });
    navigate("/auth");
  };

  return (
    <div className="ord-band">
      <div className="ord-empty">
        <img
          src="/assets/icons/order/order-placeholder.svg"
          alt=""
          aria-hidden="true"
        />

        <h2>{getLabel("myOrdersLabel")}</h2>
        <p>{getLabel("emptyOrderDescription")}</p>

        <div className="ord-empty-actions">
          <button type="button" className="ord-btn ord-btn-primary" onClick={moveToAuth}>
            {getLabel("signUpWithPhoneLabel")}
          </button>
        </div>

        <p className="ord-empty-footer">
          {getLabel("donotHaveAcc")}

          <button type="button" onClick={moveToAuth}>
            {getLabel("logInTxt")}
          </button>
        </p>
      </div>
    </div>
  );
};

export default EmptyOrderView;
